import { SignatureSelectorModal } from "MVVM/Components/Signatures";
import { usePortal } from "MVVM/Hooks/usePortal";
import { useRecoilState } from "recoil";

import { AllstarModalState } from "MVVM/State/modals";
import { ModalType } from "MVVM/@types";
import { useEffect } from "react";

export const SignatureModal = () => {
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);

  const {
    portalOpen: portalOpen,
    setPortalOpen: setPortalOpen,
    Portal: signatureSelectorPortal,
  } = usePortal(
    <SignatureSelectorModal
      onSave={() => {
        if (allstarModalState.functions.onSave)
          allstarModalState.functions.onSave();

        setAllstarModalState({
          ...allstarModalState,
          isOpen: ModalType.None,
        });
      }}
      onCloseClick={() => {
        setAllstarModalState({
          ...allstarModalState,
          isOpen: ModalType.None,
        });
      }}
    />,
  );

  useEffect(() => {
    if (allstarModalState.isOpen === ModalType.SignatureSelector) {
      setPortalOpen(true);
    }
    if (allstarModalState.isOpen === ModalType.None) {
      setPortalOpen(false);
    }
  }, [allstarModalState.isOpen, setPortalOpen]);

  return portalOpen && signatureSelectorPortal;
};
